import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Box, Copy, Image } from '@honda-canada/design-system-react';
import { compiler } from 'markdown-to-jsx';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AvailabilityStatusBadge from '../TrimCardGrid/shared/AvailabilityStatusBadge';
import { EqualHeightElement } from '../../utils/components/EqualHeight';
import themeStyles from './VehicleCard.styles';
import VehicleCardPricing from './VehicleCardPricing';
import gtmRecommendedVehicleClick from '../../core/gtm/gtmRecommendedVehicleClick';
import formatAriaLabelText from '../TrimCardGrid/utils/formatAriaLabelText';
import { statusBadgeConfig } from '../TrimCardGrid/constants';
const Card = themeStyles.apply(Box, 'Card');
const Name = themeStyles.apply(Copy, 'Name');
const VehicleImage = themeStyles.apply(Image, 'VehicleImage');
const VehicleImageLink = themeStyles.apply(Box, 'VehicleImageLink');
const RecommendedVehicleDetails = themeStyles.apply(Box, 'RecommendedVehicleDetails');
const VehicleCard = ({ vehicle, linkPathName, }) => {
    var _a;
    const { modelName, modelYear, modelKey, transmissionKey, trimKey, exteriorColorKey, interiorColorKey, exteriorColorName, interiorColorName, trimName, trimGtmName, trimImage, bodyStyle, inventoryStatus, transmissionName, } = vehicle;
    const search = `modelKey=${modelKey}&modelYear=${modelYear}&trimKey=${trimKey}&transmissionKey=${transmissionKey}&exteriorColorKey=${exteriorColorKey}&interiorColorKey=${interiorColorKey}&inventoryStatus=${inventoryStatus}`;
    const title = [modelYear, modelName, trimName].join(' ');
    const { t } = useTranslation();
    const { label } = statusBadgeConfig[inventoryStatus];
    const labelProps = {
        title,
        transmissionName,
        exteriorColorName,
        interiorColorName,
        inventoryStatus: t(label),
    };
    const ariaLabelText = formatAriaLabelText(t, labelProps);
    const handleVehicleClick = () => {
        gtmRecommendedVehicleClick({
            model: modelKey,
            trim: trimGtmName,
            gtmBodyStyle: bodyStyle,
            availabilityFlag: inventoryStatus,
        });
    };
    return (_jsxs(Card, { "data-testid": "cy-vehicle-card", children: [_jsx(EqualHeightElement, { name: "RecommendedVehicleName", children: _jsx(Box, { children: _jsx(Name, { size: "small", onClick: handleVehicleClick, as: Link, to: { pathname: linkPathName, search }, "data-testid": "cy-vehicle-name", "aria-label": ariaLabelText, children: compiler(title) }) }) }), _jsx(AvailabilityStatusBadge, { status: vehicle.inventoryStatus }), _jsx(EqualHeightElement, { name: "RecommendedVehicleDetails", children: _jsxs(RecommendedVehicleDetails, { children: [_jsx(VehicleCardPricing, { data: (_a = vehicle.paymentData) === null || _a === void 0 ? void 0 : _a.data, isFetching: vehicle.paymentData.isFetching, isLoading: vehicle.paymentData.isLoading, error: vehicle.paymentData.error }), _jsx(VehicleImageLink, { onClick: handleVehicleClick, as: Link, to: { pathname: linkPathName, search }, children: _jsx(VehicleImage, { "data-testid": "cy-vehicle-image", ...trimImage }) })] }) })] }));
};
export default VehicleCard;
